import styled, { keyframes } from 'styled-components';
import { Layout } from 'Styles/Layout.styled';
import breakpoint from 'Styles/breakpoints';
import { fontBody, fontTitle } from 'Styles/fonts';

const rotateAnimation = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const ProductReviews = styled(Layout)`
  .yotpo div,
  .yotpo span,
  .yotpo p,
  .yotpo a,
  .yotpo img,
  .yotpo i,
  .yotpo strong,
  .yotpo sup,
  .yotpo ul,
  .yotpo li,
  .yotpo form,
  .yotpo label {
    ${fontBody(16)};
    color: var(--ring);
  }

  .yotpo-widget-instance {
    margin-bottom: 48px;

    ${({ $styleQueryMode }) =>
      $styleQueryMode === 'container'
        ? 'grid-column: 1 / span 12;'
        : `grid-column: 1 / span 12;

          ${breakpoint('medium')} {
            grid-column: 2 / span 10;
          }

          ${breakpoint('large')} {
            grid-column: 3 / span 8;
          }`}
  }

  /* pages/reviews */
  #yotpo-testimonials-custom-tab {
    min-height: 100vh;

    .yotpo-modal-bottom-line {
      border: none;
    }

    .yotpo-popup-box-medium {
      text-align: center;
      margin-top: 24px;

      &:before {
        ${fontTitle(24)};
        color: var(--foreground);
        content: 'People Love Bombas';
      }

      div[data-source='default'] {
        display: flex;
        justify-content: center;
      }
    }
  }

  /* pdp reviews */
  .yotpo {
    .yotpo-label-container,
    .yotpo-label.yotpo-small-box {
      display: none;
    }

    .new-yotpo-small-box {
      margin: 0;
    }

    /**
     * Review Header
     */
    .yotpo-regular-box.yotpo-bottomline {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 0;
      padding-top: 48px;

      /* I dont know what this is */
      .pT20 {
        display: none;
      }

      &:before {
        content: 'Reviews';
        ${fontTitle(24)};
        color: var(--foreground);
        display: inline-block;
      }

      .bottom-line-items {
        display: flex;
        position: relative;
        margin-bottom: 0;
      }

      .avg-score {
        ${fontTitle(48)};
        color: var(--foreground);
        height: auto;
        padding-top: 0;
        width: auto;
      }

      .reviews-qa-labels-container {
        text-align: left;
        margin-left: 79px;
        padding-top: 28px;
        position: absolute;
        height: 44px;
      }

      .reviews-qa-label {
        display: inline-block;
        ${fontBody(14)};
        color: var(--foreground);
        width: 110px;
        height: auto;
      }

      .rating-stars-container {
        padding-top: 10px;
        margin-left: 8px;
        height: 60px !important;
        line-height: 24px;
      }

      .yotpo-bottomline-box-1.yotpo-stars-and-sum-reviews {
        max-width: none;
        min-width: 0;

        .yotpo-stars {
          padding-right: 0;
        }
      }

      .yotpo-icon-star,
      .yotpo-icon-empty-star,
      .yotpo-icon-half-star {
        color: var(--primary);
        font-size: 16px;
        height: 16px;
        line-height: 24px;
      }
    }

    /**
     * Write a Review link
     */
    .write-question-review-buttons-container {
      display: flex;
      float: none;
      justify-content: center;
      padding: 0 !important;
      margin-bottom: 0;

      .write-question-review-button {
        border: none;
        padding: 0 !important;
        margin: 0;

        .yotpo-icon {
          display: none;
        }

        .write-question-review-button-text {
          ${fontTitle(14)};
          color: var(--foreground);
          text-decoration: underline;
        }
      }
    }

    .yotpo-nav-primary {
      height: 0;
      overflow: hidden;
    }

    /**
     * Filter, Sorting, Reviews Layout
     */
    #suggested-topics-mobile-layout,
    #suggested-topics-desktop-layout {
      margin-bottom: 22px;
    }

    .suggested-topics-component {
      margin-bottom: -10px;
    }

    .suggested-topics-row {
      margin-bottom: 0 !important;
    }

    .suggested-topic {
      display: inline-block;
      padding: 6px;
    }

    .suggested-topics-row .suggested-topic .suggested-topic-text {
      color: var(--foreground);
      line-height: 12px;
    }

    .suggested-topics-row .suggested-topic.active-topic .suggested-topic-text {
      color: var(--background);
    }

    .suggested-topics-row .suggested-topic-expand {
      width: auto;
    }

    /* mobile only overrides */
    ${breakpoint('medium', { type: 'down' })} {
      .yotpo-visible-mobile,
      .mobile-more-filters-container {
        order: -1;
      }
    }

    /**
     * Filters
     */
    .yotpo-reviews-filters,
    .yotpo-nav-content,
    .new-yotpo-small-box {
      border: none;
      margin-left: 0;
      margin-right: 0;
      padding-bottom: 0;
    }

    .filters-container {
      display: grid;

      .filters-container-title {
        display: none;

        ${breakpoint('medium')} {
          display: block;
          ${fontTitle(16)};
          padding: 0;
          color: var(--foreground);
          margin-right: 15px;
          margin-bottom: 12px;
        }
      }

      .desktop-clear-all-btn {
        display: flex;
        align-items: center;
        height: 40px;
        border: none;
        padding: 0 !important;

        .desktop-clear-btn-text {
          color: var(--foreground);
          ${fontBody(14)};
          text-decoration: underline;
        }
      }

      .dropdown-filters-container {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-bottom: 22px;

        .yotpo-icon-down-triangle {
          font-size: 16px !important;
          position: absolute;
          top: 5px;
          right: 10px;

          &:before {
            font-family: var(
              --icon-font
            ) !important; /* stylelint-disable-line */
            content: '\\F005' !important;
            color: var(--ring);
          }
        }
      }

      .more-filters-btn {
        height: 40px;
        display: flex;
        align-items: normal;
        padding: 0 !important;
        margin-bottom: 0 !important;
        margin-right: 0 !important;
        border: none !important;

        &:before {
          content: 'Filter Reviews';
          margin-right: 3px;
          ${fontTitle(16)};
          color: var(--foreground);
        }

        .more-filters-text {
          display: none;
        }

        .more-filters-icon {
          &:before {
            font-family: var(
              --icon-font
            ) !important; /* stylelint-disable-line */
            content: '\\F011' !important;
          }
        }
      }

      .filters-dropdown {
        margin-top: 0 !important;

        .yotpo-dropdown-button {
          height: 40px;
          display: flex;
          align-items: center;
          padding-top: 0;
          padding-bottom: 0;
          width: 200px;
          color: var(--ring);
          border-width: 2px;
          border-color: var(--border);

          span {
            color: var(--ring);
            ${fontBody(14)};
          }
        }

        .list-categories {
          width: 200px;
          top: 38px;
          border-width: 2px;

          a {
            ${fontBody(14)};

            &.selected-item {
              font-weight: 600;
            }

            &.non-selected-item {
              color: var(--ring) !important;
            }
          }

          .non-selected-star {
            color: var(--ring) !important;
          }
        }
      }
    }

    /**
     * Filter Pills
     */

    .mobile-more-filters-container {
      .yotpo-filter-tag.yotpo-icon-btn {
        ${fontBody(14)};
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        background-color: var(--ring);
        border-radius: 18px;
        padding: 11px 12px;
        width: fit-content;
        margin-right: 0 !important;
        margin-left: auto;
        height: auto !important;
        line-height: 1;

        .filter-tag-text {
          color: var(--background);
          ${fontBody(14)};
          line-height: 1;
          margin: 0 auto;
        }

        .yotpo-icon-cross {
          display: flex;
          align-items: center;
          margin-left: 8px;
          ${fontBody(14)};
          font-size: 0.875rem !important;
          line-height: 1;

          &:before {
            font-family: var(
              --icon-font
            ) !important; /* stylelint-disable-line */
            content: '\\F000' !important;
          }
        }
      }
    }

    /**
     * Sorting
     */
    .yotpo-reviews-header {
      margin-left: 0;
      margin-right: 0;
      padding-top: 0;

      .reviews-amount {
        display: none;
      }

      .reviews-header {
        display: flex;

        .sort-drop-down .yotpo-dropdown-button span:first-child {
          ${fontTitle(16)};
          color: var(--foreground);
          padding-left: 0;
        }

        .sort-drop-down .yotpo-dropdown-button span.selected,
        .sort-drop-down .yotpo-dropdown-button span.selected-bold {
          ${fontBody(14)};
          font-weight: 500 !important;
          color: var(--ring) !important;
        }

        .sort-drop-down .yotpo-dropdown.list-categories {
          right: auto;
          left: 0;

          a {
            color: var(--foreground) !important;
            ${fontBody(14)};

            &.selected-item {
              font-weight: 600;
            }
          }
        }

        .yotpo-icon-down-triangle {
          display: none;
        }
      }
    }

    /**
     * Reviews
     */

    .yotpo-reviews {
      .yotpo-review {
        background-color: var(--background);
        padding: 24px;
        margin: 0;
        margin-bottom: 16px;
        border-radius: 8px;
        border: 2px solid var(--border) !important;

        &:last-child {
          margin-bottom: 0;
        }

        /* custom question answers */
        .yotpo-multiple-rating-fields {
          display: none;
        }
      }
    }

    /**
     * Empty Results
    */
    .yotpo-empty-search-results {
      max-width: 496px;
      margin: 0 auto;

      .empty-search-results-text {
        ${fontBody(14)};
        width: auto;
        height: auto;
        color: var(--foreground);
      }

      a.empty-search-results-clear-all-btn {
        ${fontBody(14)};
        text-decoration: underline !important;
        color: var(--foreground);
        width: auto;
        height: auto;

        &:hover {
          color: var(--foreground) !important;
        }
      }
    }

    /**
     * Pagination
    */
    .yotpo-pager {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;

      a.yotpo-page-element.goTo {
        margin-right: 30px;
      }

      a.goTo {
        ${fontBody(20)};

        &:hover {
          color: var(--foreground) !important;
        }

        &.yotpo-active {
          font-weight: 600;
        }
      }

      a.yotpo-icon {
        display: flex;
        align-items: center;
        ${fontBody(20)};

        &:hover {
          color: var(--foreground) !important;
        }
      }

      .yotpo-icon-left-arrow:before {
        font-family: var(--icon-font) !important; /* stylelint-disable-line */
        content: '\\F006';
      }

      .yotpo-icon-right-arrow {
        margin-left: 0 !important;

        &:before {
          font-family: var(--icon-font) !important; /* stylelint-disable-line */
          content: '\\F004';
        }
      }
    }

    /**
     * Loading
     */

    .search-in-progress {
      .yotpo-spinner {
        position: relative;
        .sk-spinner {
          display: none;
        }

        &:before {
          content: '';
          width: 24px;
          height: 24px;
          position: absolute;
          top: 20px;
          margin: -12px;
          border: 2px solid var(--border);
          border-top-color: var(--foreground);
          border-radius: 24px;
          animation: ${rotateAnimation} 750ms linear infinite;
        }
      }
    }
  }
`;

export default {};
